module.exports = __webpack_public_path__ + "images/choices/gujia-f7c51a13213312ce19e335b00a16effe.png";